import { render, staticRenderFns } from "./StoreInfo.vue?vue&type=template&id=27cfa274&scoped=true"
import script from "./StoreInfo.vue?vue&type=script&lang=js"
export * from "./StoreInfo.vue?vue&type=script&lang=js"
import style0 from "./StoreInfo.vue?vue&type=style&index=0&id=27cfa274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cfa274",
  null
  
)

export default component.exports